import "./Donate.module.css";
import Header from "@/reusable_sections/Header";
import FinalCallToAction from "./sections/FinalCallToAction";
import WhoIsTomorrowFor from "./sections/WhoIsTomorrowFor";
import Donation from "./sections/Donation";
import FooterInfo from "@/reusable_sections/Footer";
export default function DonatePage() {
  return <div className="bg-background text-foreground min-h-screen">
      <Header />
      <main>
        <FinalCallToAction />
        <WhoIsTomorrowFor />
        <Donation />
      </main>
      <FooterInfo />
    </div>;
}